export class BaseMdl {
    public static toJsonOnModel<T>(model: T, data: any): any {
        if (!data) {
            return undefined;
        }

        const propertysInModel: string[] = Object.keys(model);
        const propertysInData: string[] = Object.keys(data);

        // 該当する項目のみ対象とする
        // ※対象データに対象モデルに存在しない項目があった場合、追加されてしまうので
        let propertyList = new Map();
        for (let i = 0; i < propertysInModel.length; i++) {
            let foundIndex = propertysInData.indexOf(propertysInModel[i]);
            if (foundIndex >= 0) {
                propertyList.set(propertysInData[foundIndex], data[propertysInData[foundIndex]]);
            }
        }
        return Array.from(propertyList)
            .map(([k, v]) => ({ [k]: v }))
            .reduce((l, r) => Object.assign(l, r), {});
    }
}
